import {css} from 'aphrodite';
import React from 'react';

import {navigate} from 'BenchlingUtil';
import {schemaInterfaceURL} from 'schemas/schema-interface/SchemaInterfaceDAO';
import {schemaFieldsetName} from 'schemas/schema-interface/util/schemaFieldsetName';
import {SchemaInterface} from 'schemas/SchemaConstants';
import {GRAY} from 'ui-library/Colors';
import Tooltip, {styles} from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

type SchemaInterfaceIdAndName = Pick<SchemaInterface, 'id' | 'name'>;

interface SetBySchemaInterfaceTooltipProps {
  schemaInterfaceIdAndName: SchemaInterfaceIdAndName;
}

export default function SetBySchemaInterfaceTooltip({
  schemaInterfaceIdAndName: {id, name},
}: SetBySchemaInterfaceTooltipProps): JSX.Element {
  return <SchemaInterfaceTooltip schemaInterfaceIdAndName={{id, name}} textBefore="Set by" />;
}

interface SchemaInterfaceTooltipProps {
  schemaInterfaceIdAndName: SchemaInterfaceIdAndName;
  textBefore?: string;
}

export function SchemaInterfaceTooltip({
  schemaInterfaceIdAndName: {id, name},
  textBefore,
}: SchemaInterfaceTooltipProps): JSX.Element {
  const url = schemaInterfaceURL(id);
  return (
    <Tooltip
      text={
        <div className={css(styles.tooltipText)}>
          {textBefore}{' '}
          <a href={url} onClick={navigate}>
            {name}
          </a>{' '}
          {schemaFieldsetName()}
        </div>
      }
    >
      <BenchlingIcon icon="schema_interface" style={{color: GRAY}} />
    </Tooltip>
  );
}
